import React, { useEffect, useState } from "react";
import "./title.css";
const titleArr = [
  "a software engineer",
  "a web developer",
  "a front end developer",
];
export default function Title() {
  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setFade(true);
      }, 2000);

      setIndex((prevIndex) => (prevIndex + 1) % titleArr.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="title">
      <p
        className={`fs-3 text-center mt-4 ${
          fade ? "title-fade-in" : "title-fade-out"
        } `}
      >
        I am <span className="text-success ">{titleArr[index]}</span>
      </p>
    </div>
  );
}
